import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'as-list-group',
  templateUrl: './list-group.component.html',
  styleUrls: ['./list-group.component.scss']
})


export class ListGroupComponent implements OnInit {

  @Input() data: any;

  constructor() { 

   
  } 

  ngOnInit() {

  } 

}
